module.exports = __webpack_public_path__ + "static/media/logo_namabank.446007bf.svg";